<template>
  <div style="padding-top: 10px; height: 100%; box-sizing: border-box; display: flex; flex-direction: column;">
    <ChatBox ref="chatBox" style="flex: 1; min-height: 0;" :currentAvatarUrl="user.avatar || user.avatarUrl"
      :currentUserName="user.userName || user.username || user.name || (user.email ? user.email.split('@')[0] : $t('default_username'))"
      :chatMsgListStyle="{ minHeight: '0', maxHeight: 'none', backgroundColor: '#ECEAE6', padding: '12px' }" />
  </div>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'
import { Col, Row, Button, Popup } from 'vant'
Vue.use(Col)
Vue.use(Row)
Vue.use(Button)
Vue.use(Popup)
import ChatBox from './ChatBox'
export default {
  name: 'AiMatch',
  components: {
    'ChatBox': ChatBox,
  },
  props: {
    msg: String
  },
  data() {
    return {
      value: '',
    }
  },
  computed: {
    user() {
      return this.$store.state.user || {}
    },
  },
  methods: {
    clearChannel() {
      if (this.$refs.chatBox) {
        this.$refs.chatBox.clearSelectedChannel()
      }
    },
    howItWorks: function (e) {
      this.showHowItWorksModel = true
    },
    startNewSession() {
      // 通过 ref 调用 ChatBox 的方法
      if (this.$refs.chatBox) {
        this.$refs.chatBox.createNewSession()
      }
    },
    removeURLParameter(url, parameter) {
      //prefer to use l.search if you have a location/link object
      var urlparts = url.split('?');
      if (urlparts.length >= 2) {

        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {
          //idiom for string.startsWith
          if (pars[i].lastIndexOf(prefix, 0) !== -1) {
            pars.splice(i, 1);
          }
        }

        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
      }
      return url;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ai-name {
  font-size: 13px;
  color: #8A8A8A;
  font-weight: 500;
  margin-bottom: 4px;
  padding-left: 4px;
}

.ai-msg {
  background: #F7F5F2;
  padding: 10px 12px;
  border-radius: 4px;
  position: relative;
  margin-left: 4px;
  word-break: break-word;
  display: inline-block;
}

.ai-tip {
  padding: 8px 16px;
  text-align: center;
}

.ai-tip p {
  font-size: 10px;
  color: #8A8A8A;
  line-height: 1.5;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/AiMatch.vue